import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPermohonanKPRSubsidi2 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPermohonanKPRSubsidi2 = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN PEMOHON KPR BERSUBSIDI BTN
        </div>

        <div style={{ padding: "10px" }}>
          <p>Berkenaan dengan persetujuan Kredit Pemilikan Rumah Bersubsidi BTN (KPR Bersubsidi BTN) yang disampaikan PT Bank Tabungan Negara (Persero) Tbk (Bank BTN) melalui Surat Persetujuan Pemberian Kredit (SP3K) No..................................................... Tanggal....................................................., kami yang bertanda tangan dibawah ini:</p>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Nama Lengkap</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Alamat</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "10px" }}>Selaku Calon Debitur.</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Nama Lengkap</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity_spouse ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>• Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>• Alamat</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.address_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "10px" }}>Selaku suami/istri* Calon Debitur.</div>

          <div style={{ marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>Menyatakan dengan sesungguhnya bahwa:</div>
          <ol style={{ paddingLeft: "15px" }}>
            <li>Telah melaksanakan setiap proses permohonan KPR Bersubsidi BTN sesuai dengan ketentuan Bank BTN dan menyetujui SP3K dimaksud berdasarkan itikad baik, dalam keadaan bebas, mandiri dan tidak di bawah tekanan maupun pengaruh dari pihak lain (independency).</li>
            <li>Telah menerima dan memahami dengan baik setiap penjelasan yang disampaikan Bank BTN mengenai fasilitas KPR Bersubsidi BTN, hak dan kewajiban kami sebagai Debitur serta kewajiban lainnya sesuai ketentuan peraturan perundang – undangan.</li>
            <li>Bersedia melakukan aktivasi ulang QR Code setiap tahun hingga tahun ke 5 (lima) sejak akad KPR Bersubsidi BTN sesuai dengan ketentuan Pemerintah.</li>
            <li>Bersedia menyerahkan data pribadi (KTP dan NPWP) untuk mendapatkan fasilitas KPR Sejahtera dan semua data lainnya yang diperlukan oleh Regulator melalui Bank.</li>
            <li>
              Bersedia menyerahkan dokumen bukti pelaporan Pajak :
              <br />
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>Telah menjadi wajib pajak ≥ 1 tahun dan penghasilan ≥ PTKP, melampirkan SPT PPh</li>
                <li>{`Belum menjadi wajib pajak < 1 tahun, melampirkan surat pernyataan penyerahan SPT PPh tahun selanjutnya`}.</li>
                <li>Apabila dikemudian hari diperlukan penyampaian SPT PPH, Saya bersedia menyerahkan SPT PPh kepada pihak Bank.</li>
              </ol>
            </li>
            <li>Seluruh dokumen persyaratan yang disampaikan kepada Bank BTN untuk memperoleh fasilitas subsidi adalah benar dan dapat dipertanggungjawabkan keabsahannya baik secara formil maupun material.</li>
            <li>Bersedia untuk menanggung segala biaya yang meliputi biaya asuransi, biaya pengikatan agunan, dan biaya lainnya yang timbul karena terjadinya penghentian KPR Bersubsidi BTN dan/atau perubahan/konversi menjadi KPR Non-Subsidi.</li>

            <li>
              Tidak akan menjanjikan atau memberikan sesuatu baik secara langsung dan tidak langsung, baik atas inisiatif sendiri maupun orang lain, baik dengan menggunakan sarana elektronik atau tanpa sarana elektronik, baik dalam bentuk uang atau bukan uang seperti hadiah, cinderamata, komisi, pinjaman tanpa bunga, tiket perjalanan, fasilitas penginapan, perjalanan wisata, pengobatan cuma – cuma, hiburan dan fasilitas lainnya atau bentuk lainnya kepada setiap pejabat dan/atau pegawai Bank BTN
              termasuk anggota keluarga intinya.
            </li>
            <li>Apabila dikemudian hari diketahui bahwa pernyataan kami ini dan pernyataan lainnya yang kami sampaikan kepada Bank BTN tidak benar dan/atau saya penuhi, maka saya bersedia mengembalikan seluruh subsidi yang telah saya terima dari Pemerintah, bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang – undangan dan bersedia mengubah/mengkonversi menjadi KPR Non-Subsidi.</li>
          </ol>
          <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "70%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                  }}
                >
                  Menyetujui,
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <br /> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "28px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-50px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>

              {/* Baris tanda tangan */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.name ?? "-"}
                </td>
              </tr>

              {/* Baris Mengetahui */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "12px",
                    textAlign: "center",
                  }}
                >
                  Mengetahui,
                  <br />
                  Pimpinan Tempat Bekerja/Kepala Desa/Lurah* ……………………………….
                </td>
              </tr>

              {/* Baris tanda tangan bawah */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "60px 12px 20px 12px",
                    textAlign: "center",
                  }}
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
